import React, { useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  InfoCardNewAdv,
  InfoWrapper,
  InfoTimeCard,
  InfoTimeCardAdv,
  TableAdv,
  useFormHandler,
  DevNote,
} from "../../../../../components";
import MoreActionModal from "./Modals/MoreActionModal";
import { v4 as uuidv4 } from "uuid";
import {
  CreateInvoiceByOptions,
  InvoiceEmployeesOptions,
  netTermsOptions,
} from "../../../../../assets/data/projectData";

const EditInvoice = ({ setViewApprovals, onBack }) => {
  const [moreActionModal, setMoreActionModal] = useState(false);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      createInvoiceBy: "",
      employees: "",
      billingAddress:
        " ShubhaMinds, LLC 10520 Chapell Hill road, #156 Morrisville, North california Unnited States 27560",
      fromAddress:
        " TekTree LLC 10520 Chapell Hill road, #156 Morrisville, North california Unnited States 27560",
      netTerms: "",
      invoiceDate: "",
      shippedDate: "",
      dueDate: "",
      location: "",
      class: "",
      invoiceNumber: "",
      pONumber: "",
      includePOAttachment: [],
      contactEmail: "",
      ccEmail: "",
      bccEmail: "",
      consultantName: "",
      discounts: [
        {
          id: uuidv4(),
          name: "",
          select: "",
          discount: "",
        },
      ],
      notes: "",
      statementMemo: "",
      includeNotesInInvoice: [],
      statementMemoFrom: "",
      statementMemoTo: "",
      invoiceCetegoty: "",
      attachment: [],
      payableTo: "",
    },
    {
      attachment: { type: "file" },
    },
  );

  const [tableData, setTableData] = useState([
    {
      id: 1,
      serviceSummary: "Ramesh Manthri",
      activity: "",
      qualityHrsDays: "160",
      rate: "60.00",
      amount: "9600.00 USD",

      attachment: [],
      editing: false,
    },
  ]);
  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: newValue || "" } : row,
      ),
    );
  };

  const handleAddRow = () => {
    const newRow = {
      id: Date.now().toString(),
      serviceSummary: "",
      activity: "",
      qualityHrsDays: "",
      rate: "",
      amount: "",

      attachment: [],
      editing: true,
    };
    setTableData((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (rowId) => {
    setTableData((prev) => {
      const updatedRows = prev.filter((row) => row.id !== rowId);
      return updatedRows.length > 0 ? updatedRows : prev;
    });
  };

  const handleEditRow = (rowId) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, editing: !row.editing } : row,
      ),
    );
  };

  const columns = [
    {
      key: "serviceSummary",
      label: "Service Summary",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="text"
              title=""
              size="xs"
              placeholder="Enter Name"
              value={row.serviceSummary || ""}
              onChange={(value) =>
                handleRowChange(row.id, "serviceSummary", value)
              }
            />
          ) : (
            <span>{row.serviceSummary}</span>
          )}
        </div>
      ),
    },
    {
      key: "activity",
      label: "Activity",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="text"
              placeholder="Enter details"
              title=""
              size="xs"
              value={row.activity || ""}
              onChange={(value) => handleRowChange(row.id, "activity", value)}
            />
          ) : (
            <span>{row.activity}</span>
          )}
        </div>
      ),
    },
    {
      key: "qualityHrsDays",
      label: "Quality(Hrs/days)",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.qualityHrsDays || ""}
              onChange={(value) =>
                handleRowChange(row.id, "qualityHrsDays", value)
              }
            />
          ) : (
            <span>{row.qualityHrsDays}</span>
          )}
        </div>
      ),
    },
    {
      key: "rate",
      label: "Rate",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.rate || ""}
              onChange={(value) => handleRowChange(row.id, "rate", value)}
            />
          ) : (
            <span>{row.rate}</span>
          )}
        </div>
      ),
    },

    {
      key: "amount",
      label: "Amount",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="text"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.amount || ""}
              onChange={(value) => handleRowChange(row.id, "amount", value)}
            />
          ) : (
            <span>{row.amount}</span>
          )}
        </div>
      ),
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div>
          {row.editing ? (
            <FormFieldSet
              type="file"
              placeholder="choose file"
              title=""
              size="xs"
              value={row?.attachment || []}
              onChange={(value) => handleRowChange(row.id, "attachment", value)}
              key={row.id}
            />
          ) : (
            <span>{row.attachment?.[0]?.name || ""}</span>
          )}
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => handleEditRow(row.id)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={() => handleRemoveRow(row.id)}
          />
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={() => setMoreActionModal(!moreActionModal)}
          />
        </div>
      ),
    },
  ];

  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: "",
        value: "",
      },
    ]);
  };

  const handleRemoveDiscount = (id) => {
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id),
      );
    }
  };

  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      ///
      onBack();
    }
  };

  return (
    <div className="overflow-auto w-full">
      <DevNote>
        <div>
          Infocard data is currently dummy, so a loader is not implemented.
        </div>
      </DevNote>
      <div className="border-[1px] border-neutrals-50 rounded p-3">
        <div className="flex justify-between">
          <p>Edit Invoice</p>
          <Button
            title={"Ramesh Manthri"}
            color="black"
            icon={"keyboard_control_key"}
            iconPosition="after"
            disabled
          />
          <Button
            title={"View Awaiting Invoices"}
            icon={"arrow_right_alt"}
            iconPosition="after"
            // onClick={() => {}}
            onClick={() => setViewApprovals(true)}
          />
        </div>
        <div className="mt-6 flex items-center justify-between">
          <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1">
            <FormFieldSet
              type="select"
              title="Create Invoice By"
              placeholder="select Invoice By"
              value={formData.createInvoiceBy}
              onChange={(value) => handleChange("createInvoiceBy", value)}
              error={errors.createInvoiceBy}
              options={CreateInvoiceByOptions}
            />
            <FormFieldSet
              type="select"
              title="Employees"
              placeholder="select Employee "
              value={formData.employees}
              onChange={(value) => handleChange("employees", value)}
              error={errors.employees}
              options={InvoiceEmployeesOptions}
            />
          </div>
          {/* <div className="flex min-w-[80px]">
            <InfoTimeCardAdv
              title={"Total Due"}
              value={"12776.72"}
              color="primary"
              size="xs"
              prefix=""
              suffix="USD"
            />
          </div> */}
          <InfoWrapper className={"min-w-[100px]!"}>
            <InfoCardNewAdv
              title={"Total Due"}
              value={"12776.72"}
              suffix="USD"
              layout="option12"
              valueConfig={{ decimals: 2 }}
            />
          </InfoWrapper>
        </div>

        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-4 ">
          <FormFieldSet
            type="textArea"
            title={"Billing Address"}
            placeholder="Enter Billing Address "
            value={formData.billingAddress}
            onChange={(value) => handleChange("billingAddress", value)}
            error={errors.billingAddress}
            rows={5}
          />
          <FormFieldSet
            type="textArea"
            title={"From Address"}
            placeholder="Enter From Address "
            value={formData.fromAddress}
            onChange={(value) => handleChange("fromAddress", value)}
            error={errors.fromAddress}
            rows={5}
          />
        </div>

        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl mt-4">
          <FormFieldSet
            type="select"
            title={"Net Terms"}
            placeholder="Select Net Terms "
            value={formData.netTerms}
            onChange={(value) => handleChange("netTerms", value)}
            error={errors.netTerms}
            options={netTermsOptions}
          />
          <FormFieldSet
            type="datepicker"
            title={"Invoice Date"}
            placeholder="04/04/2025"
            value={formData.invoiceDate}
            onChange={(value) => handleChange("invoiceDate", value)}
            error={errors.invoiceDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Shipped Date"}
            placeholder="45"
            value={formData.shippedDate}
            onChange={(value) => handleChange("shippedDate", value)}
            error={errors.shippedDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Due Date"}
            placeholder="Select Due Date"
            value={formData.dueDate}
            onChange={(value) => handleChange("dueDate", value)}
            error={errors.dueDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title={"Location"}
            placeholder="Enter Location"
            value={formData.location}
            onChange={(value) => handleChange("location", value)}
            error={errors.location}
          />
          <FormFieldSet
            type="text"
            title={"Class"}
            placeholder="Enter Class"
            value={formData.class}
            onChange={(value) => handleChange("class", value)}
            error={errors.class}
          />
          <FormFieldSet
            type="select"
            title={"Invoice Number"}
            placeholder="select Invoice Number"
            value={formData.invoiceNumber}
            onChange={(value) => handleChange("invoiceNumber", value)}
            error={errors.invoiceNumber}
            options={[
              {
                label: "INV-2025-0456",
                value: "INV-2025-0456",
              },
              {
                label: "INV-2024-1569",
                value: "INV-2024-1569",
              },
            ]}
          />
          <FormFieldSet
            type="text"
            title={"PO Number"}
            placeholder="Enter PO Number "
            value={formData.pONumber}
            onChange={(value) => handleChange("pONumber", value)}
            error={errors.pONumber}
          />
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "Include PO Attachment in Email",
                value: true,
              },
            ]}
            values={formData.includePOAttachment || []}
            onChange={(value) => handleChange("includePOAttachment", value)}
            multiple
            error={errors.includePOAttachment}
          />
        </div>
        <div className="mt-6">
          <p>Invoice Attachments</p>
          <Divider />
          <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl gap-x-6 gap-y-8 mt-6">
            <FormFieldSet
              type="select"
              title={"Contact Email(s)"}
              placeholder="select Contact Email"
              value={formData.contactEmail}
              onChange={(value) => handleChange("contactEmail", value)}
              error={errors.contactEmail}
              options={[
                {
                  label: "emily.johnson@yahoo.com",
                  value: "emily.johnson@yahoo.com",
                },
                {
                  label: "sarah.miller1988@gmail.com",
                  value: "sarah.miller1988@gmail.com",
                },
              ]}
            />
            <FormFieldSet
              type="textArea"
              title={"CC Email(s)"}
              placeholder="Enter CC Email(s) "
              value={formData.ccEmail}
              onChange={(value) => handleChange("ccEmail", value)}
              error={errors.ccEmail}
            />
            <FormFieldSet
              type="text"
              title={"BCC Email(s)"}
              placeholder="Enter BCC Email(s) "
              value={formData.bccEmail}
              onChange={(value) => handleChange("bccEmail", value)}
              error={errors.bccEmail}
            />
            <FormFieldSet
              type="text"
              title={"Consultant Name"}
              placeholder="Enter Consultant Name "
              value={formData.consultantName}
              onChange={(value) => handleChange("consultantName", value)}
              error={errors.consultantName}
            />
          </div>
        </div>
        <div>
          <div className="flex justify-between mt-6 mb-1 items-end">
            <p>Service Summary</p>
            <Button
              title="Add"
              color="black"
              icon="add"
              onClick={handleAddRow}
            />
          </div>
          <Divider />
          <div className="mt-3">
            <TableAdv
              tableId={`employee_invoices_invoicedetails`}
              rows={tableData}
              columns={columns}
              hideToolBar
              showSlNo
            />
          </div>
        </div>
        <div className="mt-4">
          <p>Notes & Total </p>
          <Divider />
        </div>
        <div className=" mt-2">
          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-2">
              Subtotal:
              <div className="bg-black text-white pl-3 pr-2 py-2">
                0000.00 USD
              </div>
            </div>
            <div className="flex flex-col gap-4 items-start w-full">
              {formData.discounts.map((discount) => (
                <div
                  key={discount.id}
                  className="grid grid-cols-[repeat(3,1fr)] items-start lg:grid-cols-[repeat(3,1fr)] xl:grid-cols-[repeat(4,1fr)_1.2fr] gap-6 mt-3 w-full"
                >
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      noTitle={true}
                      value={discount.name}
                      placeholder="Name"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "name", value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="select"
                      noTitle={true}
                      value={discount.type}
                      placeholder="Select"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "type", value)
                      }
                    />
                  </div>
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="Discount"
                      noTitle={true}
                      value={discount.value}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "value", value)
                      }
                    />
                  </div>
                  <div className="mt-3 flex gap-2 items-center">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      onClick={handleAddDiscount}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      onClick={() => handleRemoveDiscount(discount.id)}
                    />
                  </div>
                  <div className="text-gray-600 mt-3">0.00 USD</div>
                </div>
              ))}
            </div>
            <div className="flex gap-2 mt-3">
              discount Total:
              <div>0000.00 USD</div>
            </div>
            <div className="min-w-72 ">
              <Divider />
              <div className="flex justify-end ">
                <p>
                  Grand Total <span className="ml-7">0000.00 </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1 mt-4">
          <FormFieldSet
            type="textArea"
            title="Notes"
            placeholder="Enter Notes"
            value={formData.notes}
            onChange={(value) => handleChange("notes", value)}
            error={errors.notes}
          />
          <FormFieldSet
            type="text"
            title="Statement Memo"
            placeholder="Enter Statement Memo"
            value={formData.statementMemo}
            onChange={(value) => handleChange("statementMemo", value)}
            error={errors.statementMemo}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-2">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "Include Notes in invoice PDF",
                value: true,
              },
            ]}
            values={formData.includeNotesInInvoice || []}
            onChange={(value) => handleChange("includeNotesInInvoice", value)}
            multiple
            error={errors.includeNotesInInvoice}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-6 max-w-7xl ">
          <div className="col-span-1 flex items-start gap-3">
            <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title="Statement Memo Period From"
                placeholder=" Jun 26,2024"
                value={formData.statementMemoFrom}
                onChange={(value) => handleChange("statementMemoFrom", value)}
                error={errors.statementMemoFrom}
                showDropdown={false}
              />
            </div>

            <div className="mt-6">To</div>
            <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title=""
                placeholder=" Jun 26,2025"
                value={formData.statementMemoTo}
                onChange={(value) => handleChange("statementMemoTo", value)}
                error={errors.statementMemoTo}
                showDropdown={false}
              />
            </div>
          </div>
          <FormFieldSet
            type="select"
            title="Invoice Category"
            placeholder="Select Invoice Category"
            value={formData.invoiceCetegoty}
            onChange={(value) => handleChange("invoiceCetegoty", value)}
            error={errors.invoiceCetegoty}
            options={[
              {
                label: " ",
                value: " ",
              },
            ]}
          />
          <FormFieldSet
            type="file"
            title="Attachment"
            placeholder="Choose File"
            value={formData.attachment}
            onChange={(value) => handleChange("attachment", value)}
            error={errors.attachment}
          />
          <FormFieldSet
            type="textArea"
            title="Payable To"
            placeholder="Enter Payable To"
            value={formData.payableTo}
            onChange={(value) => handleChange("payableTo", value)}
            error={errors.payableTo}
          />
        </div>
        <div className="mt-4">
          <p>Additional Info </p>
          <Divider />
          <div className="border-[1px] border-neutrals-50 rounded p-3 min-h-[250px] mt-3">
            <h6>text Editor</h6>
          </div>
        </div>
        <div className="flex justify-end gap-3 my-6">
          <Button title={"Cancel"} variant="outlined" />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
      <MoreActionModal
        open={moreActionModal}
        onClose={() => setMoreActionModal(!moreActionModal)}
      />
    </div>
  );
};

export default EditInvoice;
